var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScaleClass3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.25 8.76265C17.25 12.3595 13.5563 15.2753 9 15.2753C4.44365 15.2753 0.75 12.3595 0.75 8.76265C0.75 5.16581 4.44365 2.25 9 2.25C13.5563 2.25 17.25 5.16581 17.25 8.76265ZM16.0368 8.76265C16.0368 11.6519 12.8863 13.9941 9 13.9941C5.1137 13.9941 1.96324 11.6519 1.96324 8.76265C1.96324 5.87339 5.1137 3.53118 9 3.53118C12.8863 3.53118 16.0368 5.87339 16.0368 8.76265ZM12.2224 5.02589H6.03V6.09354H7.09764V11.2182H6.03V12.2859H12.2224V11.2182H11.3682L11.3682 6.09354H12.2224V5.02589ZM7.95176 11.2182V6.09354H8.80588V11.2182H7.95176ZM10.5141 6.09354H9.66L9.66 11.2182H10.5141V6.09354Z",
    fill: "#5D6B72"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScaleClass3);
export default __webpack_public_path__ + "static/media/scale-class-3.bff51141.svg";
export { ForwardRef as ReactComponent };